import { $userRoleManager } from './$userRoleManager'

/**
 * UserRolesの挙動をInstall
 */
export const useUserRolesFeature = () => {
  // Add
  $core.$userRoleManager = $userRoleManager()
}
